// This file contains all the getters which was in index.ts before module structure creation
// TODO: Clean this file

const permanentOverlay = (state) => {
  return state.navigationDrawerTasks.active ||
        state.navigationDrawerDocuments.active
}

export default { permanentOverlay }
